import { Controller } from "@hotwired/stimulus"

// Measure the existing navbar/breadcrumb layout rather than hard-code its size.
export class SmsWorkspaceController extends Controller {
    connect() {
        this.resize = () => this.layout()
        this.observer = new ResizeObserver(this.resize)
        this.observer.observe(this.element)
        window.addEventListener("resize", this.resize)
        window.visualViewport?.addEventListener("resize", this.resize)
        this.layout()
    }

    disconnect() {
        this.observer.disconnect()
        window.removeEventListener("resize", this.resize)
        window.visualViewport?.removeEventListener("resize", this.resize)
    }

    layout() {
        const top = this.element.getBoundingClientRect().top + window.scrollY
        const height = Math.max(420, (window.visualViewport?.height || window.innerHeight) - top - 48)
        this.element.style.setProperty("--sms-workspace-height", `${height}px`)
        const thread = this.element.querySelector(".sms-workspace-thread")
        const customers = this.element.querySelector(".sms-workspace-customers")
        this.element.dataset.columns = String(Math.abs(thread.getBoundingClientRect().top - customers.getBoundingClientRect().top) < 5)
    }
}
